import { Box, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import { FaFileAlt } from "react-icons/fa";

interface SectionCardProps {
  icon: typeof FaFileAlt;
  title: string;
  children: React.ReactNode;
}

export function SectionCard({ icon, title, children }: SectionCardProps) {
  return (
    <Box
      border="1px solid"
      borderColor="#E2E8F0"
      borderRadius="16px"
      p={{ base: 4, md: 5 }}
      bg="white"
    >
      <HStack spacing={3} mb={4} align="center" justify="center">
        <Icon as={icon} color="secondary" boxSize={4} />
        <Text
          fontFamily="Lexend Deca"
          fontWeight="500"
          fontSize="sm"
          color="secondary"
          letterSpacing="0.04em"
          textTransform="uppercase"
        >
          {title}
        </Text>
      </HStack>
      <VStack align="stretch" spacing={3}>
        {children}
      </VStack>
    </Box>
  );
}
